import deepmerge from 'deepmerge';
import { useEffect, useMemo, useState } from 'react';
import { useAppSelector } from '../redux';
import { generatePageOriginPath } from '../utils/path';
export const useDynamicPaths = (args) => {
    const dynamicPages = useAppSelector(state => state.page.pages.nodes);
    const pages = useMemo(() => {
        const newPages = {};
        for (const page of args.staticPages) {
            newPages[page.id] = page;
        }
        for (const [id, page] of Object.entries(dynamicPages)) {
            newPages[id] = deepmerge(newPages[id] || {}, page);
            newPages[id].id = id;
        }
        return newPages;
    }, [dynamicPages, args.staticPages]);
    const [paths, setPaths] = useState({});
    useEffect(() => {
        const newPaths = {};
        const pagesValues = Object.values(pages);
        for (const [pageId, page] of Object.entries(pages)) {
            const pageWithId = {
                ...page,
                id: pageId
            };
            const path = generatePageOriginPath(pagesValues, pageWithId);
            if (path &&
                (path !== pageWithId.buildPath || pageWithId.deleted) &&
                pageWithId.template) {
                newPaths[path] = {
                    jaenPageId: pageWithId.id,
                    jaenTemplateId: pageWithId.template,
                    isDeleted: pageWithId.deleted
                };
            }
        }
        if (JSON.stringify(newPaths) !== JSON.stringify(paths)) {
            setPaths(newPaths);
        }
    }, [pages]);
    return paths;
};
